import React from 'react';
import { UserIcon, SettingsIcon, BellIcon, LockIcon, HelpCircleIcon, LogOutIcon, EditIcon, CameraIcon, PlusIcon } from 'lucide-react';
export function UserProfile() {
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1010">
      <div className="lg:col-span-1 space-y-6" data-id="element-1011">
        <div className="bg-card rounded-xl shadow-sm p-6 text-center" data-id="element-1012">
          <div className="relative inline-block" data-id="element-1013">
            <div className="w-24 h-24 rounded-full bg-gradient-to-r from-primary to-secondary flex items-center justify-center text-white text-3xl font-bold mx-auto" data-id="element-1014">
              JD
            </div>
            <button className="absolute bottom-0 right-0 bg-white p-1.5 rounded-full border border-gray-200 shadow-sm" data-id="element-1015">
              <CameraIcon className="w-4 h-4 text-text-secondary" data-id="element-1016" />
            </button>
          </div>
          <h2 className="text-xl font-bold mt-4 text-text-primary" data-id="element-1017">John Doe</h2>
          <p className="text-text-secondary" data-id="element-1018">john.doe@example.com</p>
          <div className="flex justify-center mt-4" data-id="element-1019">
            <span className="px-3 py-1 bg-primary/10 text-primary text-xs rounded-full" data-id="element-1020">
              Premium Member
            </span>
          </div>
          <button className="mt-6 w-full flex items-center justify-center space-x-2 border border-gray-200 rounded-lg p-2 text-text-primary hover:bg-gray-50" data-id="element-1021">
            <EditIcon className="w-4 h-4" data-id="element-1022" />
            <span className="text-sm font-medium" data-id="element-1023">Edit Profile</span>
          </button>
        </div>
        <div className="bg-card rounded-xl shadow-sm overflow-hidden" data-id="element-1024">
          <div className="p-4 border-b border-gray-100" data-id="element-1025">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-1026">
              Settings
            </h2>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-1027">
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left" data-id="element-1028">
              <UserIcon className="w-5 h-5 text-text-secondary mr-3" data-id="element-1029" />
              <span className="text-text-primary" data-id="element-1030">Account Information</span>
            </button>
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left" data-id="element-1031">
              <BellIcon className="w-5 h-5 text-text-secondary mr-3" data-id="element-1032" />
              <span className="text-text-primary" data-id="element-1033">Notifications</span>
            </button>
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left" data-id="element-1034">
              <LockIcon className="w-5 h-5 text-text-secondary mr-3" data-id="element-1035" />
              <span className="text-text-primary" data-id="element-1036">Privacy & Security</span>
            </button>
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left" data-id="element-1037">
              <SettingsIcon className="w-5 h-5 text-text-secondary mr-3" data-id="element-1038" />
              <span className="text-text-primary" data-id="element-1039">Preferences</span>
            </button>
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left" data-id="element-1040">
              <HelpCircleIcon className="w-5 h-5 text-text-secondary mr-3" data-id="element-1041" />
              <span className="text-text-primary" data-id="element-1042">Help & Support</span>
            </button>
            <button className="w-full flex items-center p-4 hover:bg-gray-50 text-left text-red-500" data-id="element-1043">
              <LogOutIcon className="w-5 h-5 mr-3" data-id="element-1044" />
              <span data-id="element-1045">Log Out</span>
            </button>
          </div>
        </div>
      </div>
      <div className="lg:col-span-2 space-y-6" data-id="element-1046">
        <div className="bg-card rounded-xl shadow-sm" data-id="element-1047">
          <div className="p-4 border-b border-gray-100" data-id="element-1048">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-1049">
              Account Overview
            </h2>
          </div>
          <div className="p-6" data-id="element-1050">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1051">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1052">
                <p className="text-text-secondary text-sm" data-id="element-1053">Total Balance</p>
                <p className="text-2xl font-bold text-text-primary mt-1" data-id="element-1054">
                  £16,938.00
                </p>
                <div className="flex items-center mt-1" data-id="element-1055">
                  <span className="text-xs px-1.5 py-0.5 bg-green-100 text-green-700 rounded" data-id="element-1056">
                    +2.4%
                  </span>
                  <span className="text-xs text-text-muted ml-2" data-id="element-1057">
                    from last month
                  </span>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1058">
                <p className="text-text-secondary text-sm" data-id="element-1059">Reward Points</p>
                <p className="text-2xl font-bold text-text-primary mt-1" data-id="element-1060">
                  2,450 pts
                </p>
                <div className="flex items-center mt-1" data-id="element-1061">
                  <span className="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded" data-id="element-1062">
                    180 pts
                  </span>
                  <span className="text-xs text-text-muted ml-2" data-id="element-1063">
                    earned this month
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-6" data-id="element-1064">
              <h3 className="text-md font-semibold text-text-primary mb-3" data-id="element-1065">
                Linked Accounts
              </h3>
              <div className="space-y-3" data-id="element-1066">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1067">
                  <div className="flex items-center" data-id="element-1068">
                    <img src="https://logo.clearbit.com/barclays.co.uk" alt="Barclays" className="w-8 h-8 rounded mr-3 bg-white p-1" onError={e => {
                    e.currentTarget.src = 'https://via.placeholder.com/32/ffffff/000000?text=B';
                  }} data-id="element-1069" />
                    <div data-id="element-1070">
                      <p className="font-medium text-text-primary" data-id="element-1071">Barclays</p>
                      <p className="text-xs text-text-muted" data-id="element-1072">****6789</p>
                    </div>
                  </div>
                  <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded" data-id="element-1073">
                    Connected
                  </span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1074">
                  <div className="flex items-center" data-id="element-1075">
                    <img src="https://logo.clearbit.com/lloydsbank.com" alt="Lloyds" className="w-8 h-8 rounded mr-3 bg-white p-1" onError={e => {
                    e.currentTarget.src = 'https://via.placeholder.com/32/ffffff/000000?text=L';
                  }} data-id="element-1076" />
                    <div data-id="element-1077">
                      <p className="font-medium text-text-primary" data-id="element-1078">
                        Lloyds Bank
                      </p>
                      <p className="text-xs text-text-muted" data-id="element-1079">****4321</p>
                    </div>
                  </div>
                  <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded" data-id="element-1080">
                    Connected
                  </span>
                </div>
              </div>
              <button className="mt-3 flex items-center text-primary text-sm font-medium" data-id="element-1081">
                <PlusIcon className="w-4 h-4 mr-1" data-id="element-1082" />
                Link Another Account
              </button>
            </div>
          </div>
        </div>
        <div className="bg-card rounded-xl shadow-sm" data-id="element-1083">
          <div className="p-4 border-b border-gray-100" data-id="element-1084">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-1085">
              Financial Goals
            </h2>
          </div>
          <div className="p-6 space-y-4" data-id="element-1086">
            <div data-id="element-1087">
              <div className="flex justify-between mb-1" data-id="element-1088">
                <div data-id="element-1089">
                  <p className="font-medium text-text-primary" data-id="element-1090">Holiday Fund</p>
                  <p className="text-xs text-text-muted" data-id="element-1091">
                    Target: September 2023
                  </p>
                </div>
                <p className="text-sm font-medium text-text-primary" data-id="element-1092">
                  £1,200 / £3,000
                </p>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-1093">
                <div className="bg-primary h-full rounded-full" style={{
                width: '40%'
              }} data-id="element-1094"></div>
              </div>
              <p className="text-xs text-right text-text-muted mt-1" data-id="element-1095">
                40% complete
              </p>
            </div>
            <div data-id="element-1096">
              <div className="flex justify-between mb-1" data-id="element-1097">
                <div data-id="element-1098">
                  <p className="font-medium text-text-primary" data-id="element-1099">New Laptop</p>
                  <p className="text-xs text-text-muted" data-id="element-1100">
                    Target: December 2023
                  </p>
                </div>
                <p className="text-sm font-medium text-text-primary" data-id="element-1101">
                  £800 / £1,200
                </p>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-1102">
                <div className="bg-primary h-full rounded-full" style={{
                width: '67%'
              }} data-id="element-1103"></div>
              </div>
              <p className="text-xs text-right text-text-muted mt-1" data-id="element-1104">
                67% complete
              </p>
            </div>
            <div data-id="element-1105">
              <div className="flex justify-between mb-1" data-id="element-1106">
                <div data-id="element-1107">
                  <p className="font-medium text-text-primary" data-id="element-1108">
                    Emergency Fund
                  </p>
                  <p className="text-xs text-text-muted" data-id="element-1109">Ongoing</p>
                </div>
                <p className="text-sm font-medium text-text-primary" data-id="element-1110">
                  £4,500 / £10,000
                </p>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-1111">
                <div className="bg-primary h-full rounded-full" style={{
                width: '45%'
              }} data-id="element-1112"></div>
              </div>
              <p className="text-xs text-right text-text-muted mt-1" data-id="element-1113">
                45% complete
              </p>
            </div>
            <button className="mt-2 w-full flex items-center justify-center space-x-2 border border-gray-200 rounded-lg p-2 text-text-primary hover:bg-gray-50" data-id="element-1114">
              <PlusIcon className="w-4 h-4" data-id="element-1115" />
              <span className="text-sm font-medium" data-id="element-1116">Add New Goal</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}